export default {
	'please-select-an-account': 'Por favor seleccione una cuenta',
	'show-archived': 'Mostrar archivada',
}